"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue } from "vue-property-decorator";
import API from "@ym-framework/api-utils";
import vueQr from "vue-qr";
import { PaymentNomoneyModel } from "@/models/paymentModels/paymentNomoney.model";
import { CoinOrderModel } from "@/models/costModels/CoinOrder.model";
import { Debounce } from "vue-debounce-decorator";
import DateFormat from "@/framework/timeformatter";
let PaymentPurchaseConfirmation = class extends Vue {
  constructor() {
    super(...arguments);
    this.paymentType = true;
    this.paymentTimeWait = null;
    this.paymentItem = new PaymentNomoneyModel();
    this.paymentCoinItem = new CoinOrderModel();
    this.order_id = "";
    this.paymentStyle = "create";
    this.paymentWay = "alipay";
    this.paymentStatus = "confirm";
    this.qrCode = "https://www.kuajingvs.com";
    this.payment_time_last = 5;
    this.return_style = "normal";
    this.pp_pay_pic = "";
    this.uploadUrl = "";
    this.pp_pay_code = "";
    this.confirm_lock = false;
    // 定义一个空对象 装载TimeOut对象
    this.jumperTimeOut = null;
  }
  timer_last() {
    let timer_last = setInterval(() => {
      if (this.payment_time_last >= 0) {
        this.payment_time_last = this.payment_time_last - 1;
      }
      if (this.payment_time_last < 0) {
        clearInterval(timer_last);
        this.payment_time_last = 5;
      }
    }, 1e3);
  }
  mounted() {
    return __async(this, null, function* () {
      let way = "";
      if (this.$route.query.hasOwnProperty("style")) {
        this.paymentStyle = this.$route.query.style;
      }
      if (this.$route.query.hasOwnProperty("qr")) {
        this.qrCode = this.$route.query.qr;
      }
      if (this.$route.query.hasOwnProperty("id")) {
        try {
          this.order_id = this.$route.query.id;
          let order_response = yield API.get(
            `api://base.auth/api/v7/orders/${this.order_id}`
          );
          this.paymentItem = order_response.data;
        } catch (error) {
          this.paymentStatus = "error";
          if (error.hasOwnProperty("response")) {
            this.$message.error(error.response.data.errors.datas[0].message);
          }
        }
      }
      if (this.$route.query.hasOwnProperty("t")) {
        way = this.$route.query.t;
      }
      this.return_style = "normal";
      let jump = "";
      if (this.$route.query.hasOwnProperty("jump")) {
        jump = this.$route.query.jump;
      }
      if (way === "alipay") {
        this.paymentWay = "alipay";
      }
      if (way === "wechat") {
        this.paymentWay = "wechat";
      }
      this.qrCode = this.$route.query.qr;
      if (this.$route.query.hasOwnProperty("gift")) {
        if (this.$route.query.gift || this.$route.query.gift === "true") {
          this.paymentType = false;
        }
        if (!this.$route.query.gift || this.$route.query.gift === "false") {
          this.paymentType = true;
        }
      }
      if (this.paymentType) {
        try {
          let waitPayment = new Promise((resolve, reject) => {
            let waitTimer = setInterval(() => __async(this, null, function* () {
              if (!this.order_id) {
                clearInterval(waitTimer);
              }
              let wait_response = yield API.get(
                `api://base.auth/api/v7/orders/${this.order_id}/check_pay_status`
              );
              if (wait_response.data.order_has_paid) {
                this.paymentStatus = "success";
                yield this.time_wait();
                this.timer_last();
                clearInterval(waitTimer);
                resolve(this);
                this.jumperTimeOut = setTimeout(() => {
                  this.$router.push({
                    path: "/midsafety"
                  });
                }, 5e3);
              }
            }), 1e3);
            setTimeout(() => {
              clearInterval(waitTimer);
              resolve(this);
            }, 12e4);
          });
        } catch (error) {
          this.paymentStatus = "error";
          if (error.hasOwnProperty("response")) {
            this.$message.error(error.response.data.errors.datas[0].message);
          }
        }
      }
    });
  }
  JumpToDashboard() {
    if (this.jumperTimeOut !== null) {
      clearTimeout(this.jumperTimeOut);
    }
    this.$router.push("/midsafety");
  }
  format_min(time) {
    if (time === 0 || time === null) {
      return "--";
    } else {
      return DateFormat.dateformatter(DateFormat.check(time));
    }
  }
  checkConfirm() {
    return __async(this, null, function* () {
      try {
        this.confirm_lock = true;
        yield this.ConfirmOrder();
      } catch (error) {
        console.log(error);
      }
    });
  }
  ConfirmOrder() {
    return __async(this, null, function* () {
      if (this.paymentType && this.paymentWay === "paypal") {
        if (!this.pp_pay_pic) {
          this.$message.error(
            this.$t(
              "change_paypal_account_dialog.paypal_pay_pic_require"
            )
          );
          this.confirm_lock = false;
          return;
        }
        if (!this.pp_pay_code) {
          this.$message.error(
            this.$t("change_paypal_account_dialog.paypal_code_require")
          );
          this.confirm_lock = false;
          return;
        }
        if (!/^\d{6}$/.test(this.pp_pay_code)) {
          this.$message.error(
            this.$t("change_paypal_account_dialog.paypal_code_format")
          );
          this.confirm_lock = false;
          return;
        }
      }
      try {
        let result = yield API.put(
          // `api://base.auth/api/v7/orders/${this.order_id}/confirm`
          `api://base.auth/api/v8/orders/${this.order_id}/confirm`,
          {}
        );
        this.paymentStatus = "success";
        yield this.time_wait();
        this.timer_last();
        this.confirm_lock = false;
        this.jumperTimeOut = setTimeout(() => {
          this.$router.push({
            path: "/midsafety"
          });
        }, 5e3);
      } catch (error) {
        this.paymentStatus = "error";
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      } finally {
        this.confirm_lock = false;
      }
    });
  }
  time_wait() {
    return __async(this, null, function* () {
      try {
        let order_response = yield API.get(
          `api://base.auth/api/v7/orders/${this.order_id}`
        );
        this.paymentTimeWait = order_response.data.order.expire_time;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  cancelOrder() {
    return __async(this, null, function* () {
      try {
        if (this.paymentStyle === "coin") {
          let response2 = yield API.put(
            `api://base.auth/api/v7/orders/${this.order_id}/cancel`
          );
          this.$message.info(
            this.$t("paymentconfirmation.order_canceled")
          );
          this.$router.push({
            path: "/cost"
          });
          return;
        }
        let response = yield API.put(
          `api://base.auth/api/v7/orders/${this.order_id}/cancel`
        );
        this.$message.info(
          this.$t("paymentconfirmation.order_canceled")
        );
        this.$router.push({
          path: "/vd_list"
        });
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  goBack() {
    this.$router.go(-1);
  }
  beforeAvatarUpload(file) {
    const isPic = file.type === "image/jpeg" || file.type === "image/png";
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isPic) {
      this.$message.error(
        this.$t("change_paypal_account_dialog.paypal_pay_type")
      );
      return isPic && isLt2M;
    }
    if (!isLt2M) {
      this.$message.error(
        this.$t("change_paypal_account_dialog.paypal_pay_size")
      );
      return isPic && isLt2M;
    }
    return isPic && isLt2M;
  }
  handleAvatarSuccess(res, file) {
    this.pp_pay_pic = URL.createObjectURL(file.raw);
  }
  stopPropagation() {
    event.stopPropagation();
  }
  handleRemove() {
    this.pp_pay_pic = "";
  }
  sendCode() {
    return __async(this, null, function* () {
      try {
        yield API.post(
          `api://base.auth/api/v8/verify-code-send-order-confirm/${this.order_id}`
        );
        this.$message.success(
          this.$t("change_paypal_account_dialog.paypal_code_send")
        );
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
};
__decorateClass([
  Debounce(800)
], PaymentPurchaseConfirmation.prototype, "ConfirmOrder", 1);
PaymentPurchaseConfirmation = __decorateClass([
  Component({
    components: {
      vueQr
    }
  })
], PaymentPurchaseConfirmation);
export {
  PaymentPurchaseConfirmation as default
};
